module.exports = __webpack_public_path__ + "b177c0a94a31d4a8672d1f391955077a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/logo/Spotin_TM_Logo_Blue_Big_RGB.png
// module id = 183
// module chunks = 0